<template>
  <el-config-provider :locale="zhTw">
    <el-container style="height: 100vh">
      <el-header v-if="$route.meta.showNav" class="headerBox pcShow">
        <div class="platformBox">
          代理商管理系統 2.1
        </div>
        <div class="topMain">
          <div>
            <span class="orangeFont">Hi, </span>
            <span>{{username}}</span>
          </div>
          <div>
            <span class="orangeFont">當前代理: </span>
            <span>{{agentname}}</span>
          </div>
          <div>
            <span class="orangeFont">額度: </span>
            <!--            <span>{{agent.credit - agent.credit_used}}/{{agent.credit}}</span>-->
            <span>{{formatNumber(agent.credit - agent.credit_used)}}</span>
          </div>
        </div>
        <div class="topRight">
          <!--          <span class="orangeFont">時區：</span>-->
          <!--          <span>中國/香港</span>-->
        </div>
      </el-header>
      <el-header v-if="$route.meta.showNav" class="headerBox mobileShow">
        <div @click="menuFun" class="navBox">
          <img height="30px" width="30px" :src="require('@/assets/img/ico/nav.png')" alt="">
        </div>
<!--        <img @click="menuFun" height="30px" width="30px" :src="require('@/assets/img/ico/nav.png')" alt="">-->
        <div class="topMain">
          <div>
            <span class="orangeFont">Hi, </span>
            <span>{{username}}</span>
          </div>
        </div>
        <div class="topRight">
          <!--          <span class="orangeFont">時區：</span>-->
          <!--          <span>中國/香港</span>-->
        </div>
      </el-header>
      <el-container>
        <leftBar
            :showManu="showManu"
            v-if="$route.meta.showNav"
            @view-path="viewPa"
        />
        <div :class="!showMask ? 'mobileShow maskBox' : 'maskBox'">
          {{showMask}}
        </div>
        <el-main :class="$route.path !== '/login' ? 'pcHeight' : ''">
  <!--        <div class="tabsBox">-->
  <!--          <span class="tabsItem is-active" v-for="(item,index) in editableTabs" :key="index">-->
  <!--            <span>{{item.title}}</span>-->
  <!--            <el-icon><Close /></el-icon>-->
  <!--          </span>-->
  <!--        </div>-->
  <!--        <router-view/>-->
          <div class="pcShow                                                                                                                          tabBox">

            <el-tabs
                v-if="$route.meta.showNav"
                v-model="editableTabsValue"
                type="card"
                class="demo-tabs"
                @tab-click="(tab, event) => changeTab(tab, event, 'extraArg')"
                @tab-remove="(tab) => removeTab(tab)"
            >
              <el-tab-pane
                  v-for="item in editableTabs"
                  :key="item.name"
                  :name="item.name"
                  :closable="item.closable"
              >
                <template #label>
                  <div class="tabsTitle">
                    {{item.title}}
                  </div>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
<!--          <router-view v-slot="{ Component }">-->
<!--            <keep-alive :include="cachedPages">-->
<!--              <component :is="Component" />-->
<!--            </keep-alive>-->
<!--          </router-view>-->
          <router-view @view-path="viewPa" :searchUsername="searchUsername" :searchType="searchType">
          </router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-config-provider>
</template>

<script>
import { ElConfigProvider, ElMessage, ElMessageBox } from 'element-plus'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import leftBar from './components/leftBar.vue'
import {onMounted, reactive, toRefs, watch} from "vue"
import { useRouter, useRoute } from 'vue-router'
import api from '@/js/api.js'

// import {
//   Close
// } from '@element-plus/icons-vue'

export default {
  name: 'App',
  components: {
    leftBar,
    ElConfigProvider,
    // Close
  },
  setup() {
    // const cachedPages = ref(['Home', 'UserProfile'])
    const { push } = useRouter()
    // const { path } = useRoute()
    const route = useRoute()
    const data = reactive({
      zhTw: zhTw,
      tabIndex : '1',
      editableTabsValue : '/',
      username: '',
      agentname: '',
      editableTabs: [
        {
          title: '公告版',
          name: '/',
          closable: false
        }
      ],
      agent: {
        credit: 0
      },
      routeLoad: true,
      searchUsername: '',
      searchType: '',
      showManu: true,
      showMask: true
    })// 数据
    const methods = {
      menuShowFun (val) {
        console.log(val)
        data.showManu = false
        data.showMask = true
      },
      menuFun () {
        data.showManu = !data.showManu
        data.showMask = !data.showMask
      },
// JS 自带的 toLocaleString
      formatNumber (num) {
        // return Number(num).toLocaleString()
        // console.log(num, typeof num)
        // num = num / 1000
        num = num.toFixed(2)
        return num.toString().replace(/\d+/, function (n) {
          return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        })
      },
      handleTabsEdit (targetName, targetindex, action, isClosable) {
        if (action === 'add') {
          if (data.editableTabs.find(item => item.name === targetindex)) {
            return
          }
          const newTabName = targetName
          data.editableTabs.push({
            title: newTabName,
            name: targetindex,
            closable: isClosable,
          })
          data.editableTabsValue = targetindex
          sessionStorage.setItem('tabList',JSON.stringify(data.editableTabs))
          push(targetindex)
        } else if (action === 'remove') {
          const tabs = data.editableTabs
          let activeName = data.editableTabsValue
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                const nextTab = tabs[index + 1] || tabs[index - 1]
                if (nextTab) {
                  activeName = nextTab.name
                }
              }
            })
          }
          data.editableTabs = tabs.filter((tab) => tab.name !== targetName)
          sessionStorage.setItem('nowRouter', activeName)
          sessionStorage.setItem('tabList',JSON.stringify(data.editableTabs))
          push(activeName)
          data.editableTabsValue = activeName
        }
      },
      changeTab (tab) {
        sessionStorage.setItem('nowRouter', tab.props.name)
        data.editableTabsValue = tab.props.name
        push(tab.props.name)
      },
      removeTab (tab) {
        // localStorage.setItem('nowRouter', tab.props.name)
        // push(tab.props.name)
        methods.handleTabsEdit(tab,'','remove')
      },
      viewPa(pro) {
        // const newTab = pro
        data.searchUsername = pro.search
        data.searchType = pro.type
        // provide('searchUsername',pro.search)
        // provide('searchType',pro.type)
        methods.handleTabsEdit(pro.title, pro.index,'add', pro.closable)
        data.editableTabsValue = pro.index
        data.showMask = true
        // data.showManu = !data.showManu
        // data.editableTabs.push(newTab)
      },
      getAgent() {
        api.post('info', {
          requestName: 'agent-info-app'
        }).then(res => {
          if (res.data.result !== undefined && res.data.status === 'M00000') {
            data.agent = res.data.result
          }

        })
      },
      adPop () {
        ElMessageBox.alert(
            '富胖達重要公告\n' +
            '<br/>' +
            '親愛的會員朋友們:\n' +
            '<br/>' +
            '<br/>' +
            '近日我們留意到部分合作夥伴的系統偶有不穩定的情況,這可能短暫影響到您的注單呈現或餘額顯示。富胖達團隊深知這可能為您帶來困擾與不便,在此致上我們最誠摯的歉意。同時,也非常感謝大家在這段時間依然給予我們持續的理解與支持,這對我們至關重要。\n' +
            '<br/>' +
            '<br/>' +
            '針對此類源於合作夥伴系統的突發狀況,我們希望能與您坦誠溝通以下幾點處理原則,以共同維護一個公平且穩定的遊戲環境:\n' +
            '<br/>' +
            '<br/>' +
            '若因第三方合作夥伴系統的偶發性錯誤,導致您的遊戲資料(包括但不限於金額、遊戲紀錄、積分、獎勵等)出現非預期的變動時,此類情況的源頭並非本平台系統直接導致。\n' +
            '<br/>' +
            '為確保所有會員的權益與帳戶數據的準確性,當此類情況發生時,富胖達團隊將會謹慎地依據我們系統後台最原始且完整的數據記錄,進行核實與必要的調整作業,力求將影響降至最低。\n' +
            '<br/>' +
            '所有帳務的最終確認,都將以富胖達平台系統後台的詳細記錄為最準確的依歸。我們理解這需要您的信任,這也是我們確保數據一致性的重要方式。\n' +
            '<br/>' +
            '倘若以上說明未能完全釋除您目前的疑慮,為了讓您能有更安心的遊戲體驗,我們誠懇地建議您可以考慮暫時放緩遊戲的節奏,待相關合作夥伴的系統全面恢復穩定,您的疑慮也得到釐清後,再無憂地投入遊戲。我們希望能盡力避免因第三方系統的突發狀況,而造成您任何不必要的困擾或誤解。\n' +
            '<br/>' +
            '<br/>' +
            '富胖達團隊將持續努力,為各位會員的遊戲品質與帳戶安全嚴格把關,並積極與合作夥伴溝通協調,提升整體服務的穩定性。\n' +
            '<br/>' +
            '<br/>' +
            '再次衷心感謝您的理解、耐心與長久以來的支持。',
            '關於近期合作夥伴系統波動影響及帳務說明',
            {
              roundButton: true,
              showClose: false,
              dangerouslyUseHTMLString: true,
              confirmButtonText: '確認',
              confirmButtonClass: 'msgConfirmBtn',
              showCancelButton: true,
              cancelButtonText: '今日不再顯示',
              cancelButtonClass: 'msgCancelBtn',
            }
        )
            .then(() => {
              ElMessage({
                type: 'success',
                message: 'Delete completed',
              })
            })
            .catch(() => {
              ElMessage({
                type: 'info',
                message: 'Delete canceled',
              })
            })
      }
    } // 事件
    onMounted(()=>{
      // methods.adPop()

      // console.log(localStorage.token)
      // if(!localStorage.token) {
      //   window.location.href='/login'
      //   return
      // }
      data.username = localStorage.username
      data.agentname = localStorage.agent
      var tabList = []
      if (!JSON.parse(sessionStorage.getItem('tabList'))) {
        tabList.push({
          title: '公告版',
          name: '/'
        })
        data.editableTabs = tabList
        sessionStorage.setItem('tabList',JSON.stringify(tabList))
        sessionStorage.setItem('nowRouter', '/')
      }else {
        data.editableTabs = JSON.parse(sessionStorage.getItem('tabList'))
      }
      var newTabName = sessionStorage.getItem('nowRouter')
      data.editableTabsValue = newTabName
      methods.getAgent()
    })
    // 监听 route.query 中特定参数的变化
    watch(
        () => route.path, // 替换成你实际使用的参数名
        (newVal) => {
          if (newVal) {
            data.editableTabsValue = newVal
          }
        },
        {immediate: true} // 立即执行一次，处理初始状态
    )

    return {
      ...toRefs(data),
      ...methods
    }
  }
}
</script>

<style lang="scss">
.pcHeight {
  height: calc(100vh - 60px);
}
.maskBox {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 80;
}
.mobileShow {
  display: none !important;
}
.tabsTitle {
  width: 150px;
  justify-content: flex-start;
}
.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable {
  padding: 0 10px;
}

.el-message-box {
  --el-messagebox-padding-primary: 25px !important;
  --el-messagebox-width: 600px !important;
}

.msgConfirmBtn {
  background: #FCC511 !important;
  border: unset !important;
}

.msgCancelBtn {
  background: unset !important;
  border: 1px solid #595959 !important;
  color: #fff !important;
}

.tabsBox {
  background: #000;
  color: #fff;
  border-bottom: .25rem solid #6e6e6e !important;
  display: flex;
  //height: 25px !important;
  //padding: 5px 0 !important;
  .tabsItem {
    padding: 0 20px;
    position: relative;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    margin-top: -1px;
    display: flex;
    align-items: center;
    .el-icon {
      margin-left: 5px;
      animation-duration: .3s;
      transition-duration: .3s;
      cursor: pointer;
    }
    .el-icon:hover {
      background: rgba(255, 255, 255, 0.60);
      color: white;
      border-radius: 100px;
    }
  }
  .tabsItem:after {
    content: '';
    height: 15px;
    width: 1px;
    background: #fff;
    position: absolute;
    right: 0;
  }
  .tabsItem.is-active {
    color: var(--main-color) !important;
    border-bottom: .25rem solid var(--main-color) !important;
  }
}
.orangeFont {
  letter-spacing: 1.4px;
}

.headerBox {
  background: #262626;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  height: 46px !important;
  .platformBox {
    width: 245px;
  }
  .topMain {
    display: flex;
    align-items: center;
    width: 600px;
    justify-content: space-between;
  }
  .topRight {
    margin-left: auto !important;
    margin-right: 2rem !important;
  }
}

@font-face {
  font-family: PingFang TC; /* 为你引入的字体家族起一个自定义名称 */
  src: url('@/assets/font/PingFang-Bo6E5BSV.ttc') format('truetype');
}
* {
  margin: 0;
  padding: 0;
  font-family: PingFang TC,sans-serif;
}

body {
//background-color: var(--van-body-background-color);
  display: flex;
  justify-content: center;
  /*align-items: center;*/
  height: 100vh;
  height: calc(100vh - var(--browser-address-bar, 0px));
  //overflow: hidden;
  margin: 0;
  padding: 0;
  //-webkit-touch-callout: none; /*系统默认菜单被禁用*/
  //-webkit-user-select: none; /*webkit浏览器*/
  //-khtml-user-select: none; /*早起浏览器*/
  //-moz-user-select: none; /*火狐浏览器*/
  //-ms-user-select: none; /*IE浏览器*/
  //user-select: none; /*用户是否能够选中文本*/
  background: #000;
  background-color: #000 !important;
  background-position: 50% !important;
  background-size: cover !important;
  background-image: url(@/assets/img/loginBG.png);
}
#app {
  //font-family: PingFang TC, PingFang SC, 微軟雅黑, Microsoft YaHei, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
//text-align: center;
//  box-sizing: border-box;
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 100vh;
  font-size: 16px;
}

@media only screen and (max-width: 991px) {
  .pcHeight {
    height: calc(100vh - 50px) !important;
  }
  .pcShow {
    display: none;
  }
  .mobileShow {
    display: flex !important;
  }

  .maskBoxShow {
    display: unset;
  }
  .headerBox {
    z-index: 2000;
  }

  .topMain {
    margin-left: 40px;
  }
  .navBox {
    width: 70px;
    height: 70px;
    background: #262626;
    border-radius: 50%;
    position: absolute;
    top: -10px;
    left: -10px;
    img {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
}
</style>
